/* === SWIPS RUNTIME PATCHES ===
   Small fixes that cannot be made in the theme's own Liquid without editing a
   vendor file, or that depend on where the visitor has scrolled to.

   1. Palo Alto wraps the header logo in an <h1 class="logo">. Every page that
      also has a real content H1 therefore ships two of them. Demote it to a
      <div> and let the content H1 stand alone.

   2. Third party embeds arrive after page load with images that carry no alt
      attribute. They are decorative, so give them alt="" rather than a guessed
      description. Scanners flag a missing attribute, not an empty one.

   3. The sticky Get 20% off bar is fixed to the bottom of the viewport on
      mobile. Once you reach the footer it sat on top of the Privacy Policy,
      Terms, Shipping and Refund links and swallowed the taps. Hide it while any
      part of the footer is on screen. The bar has done its job by then anyway.
      This is done with an inline style rather than a class so it overrides the
      section's own is-on rule without needing a matching CSS entry, and
      clearing the inline style hands control straight back to the section.

   Nothing here changes what the page looks like above the footer.
=============================== */
(function () {
  'use strict';

  function demoteHeaderHeading() {
    var h1 = document.querySelector('header-component h1.logo, .site-header h1.logo');
    if (!h1) return;
    var div = document.createElement('div');
    for (var i = 0; i < h1.attributes.length; i++) {
      div.setAttribute(h1.attributes[i].name, h1.attributes[i].value);
    }
    while (h1.firstChild) div.appendChild(h1.firstChild);
    h1.parentNode.replaceChild(div, h1);
  }

  function labelDecorativeImages() {
    var imgs = document.querySelectorAll('img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('alt', '');
    }
  }

  function guardFooterLinks() {
    var sticky = document.querySelector('[id^="shs-"]');
    var footer = document.querySelector('.site-footer');
    if (!sticky || !footer || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.style.display = 'none';
        } else {
          sticky.style.display = '';
        }
      });
    }, { threshold: 0 }).observe(footer);
  }

  function start() {
    demoteHeaderHeading();
    labelDecorativeImages();
    guardFooterLinks();

    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.setTimeout(function () {
        pending = false;
        labelDecorativeImages();
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
